import { MtGroup, MtProjectGroup, MtUser } from "server/models"
import { inferLiteral, OrderType } from "client/utils"
import {
    PermissionType,
    CommonPermissionItem,
    CommonPermissionsSectioned,
} from "client/store/utils"
import { GroupFilters, ProjectGroupFilters, UserFilters } from "client/store"
import * as types from "./types"


export const setLifecyclePermissions = (lifecyclePermissions: CommonPermissionsSectioned) => ({
    type: inferLiteral(types.SET_LIFECYCLE_PERMISSIONS),
    lifecyclePermissions,
})

export const updateLifecyclePermission = (
    section: string,
    permissionId: string,
    type: PermissionType,
    value: CommonPermissionItem,
) => ({
    type: inferLiteral(types.UPDATE_LIFECYCLE_PERMISSION),
    data: { section, permissionId, type, value },
})

export const toggleLifecyclePermissionCustomizable = (
    section: string,
    permissionId: string,
) => ({
    type: inferLiteral(types.TOGGLE_LIFECYCLE_PERMISSION_CUSTOMIZABLE),
    section,
    permissionId,
})

// not assigned account groups
export const setLifecyclePermissionsAccountGroupIds = (groupIds: readonly number[]) => ({
    type: inferLiteral(types.LIFECYCLE_PERMISSIONS_ACCOUNT_GROUP_IDS),
    groupIds,
})
export const setLifecyclePermissionsAccountGroupSort = (sortColumn: keyof MtGroup, sortOrder: OrderType) => ({
    type: inferLiteral(types.LIFECYCLE_PERMISSIONS_ACCOUNT_GROUP_SORT),
    sortColumn,
    sortOrder,
})
export const setLifecyclePermissionsAccountGroupFilters = (filters: GroupFilters) => ({
    type: inferLiteral(types.LIFECYCLE_PERMISSIONS_ACCOUNT_GROUP_FILTERS),
    filters,
})
export const setLifecyclePermissionsAccountGroupSelected = (selected: readonly number[]) => ({
    type: inferLiteral(types.LIFECYCLE_PERMISSIONS_ACCOUNT_GROUP_SELECTED),
    selected,
})

// not assigned project groups
export const setLifecyclePermissionsProjectGroupIds = (groupIds: readonly number[]) => ({
    type: inferLiteral(types.LIFECYCLE_PERMISSIONS_PROJECT_GROUP_IDS),
    groupIds,
})
export const setLifecyclePermissionsProjectGroupSort = (sortColumn: keyof MtProjectGroup, sortOrder: OrderType) => ({
    type: inferLiteral(types.LIFECYCLE_PERMISSIONS_PROJECT_GROUP_SORT),
    sortColumn,
    sortOrder,
})
export const setLifecyclePermissionsProjectGroupFilters = (filters: ProjectGroupFilters) => ({
    type: inferLiteral(types.LIFECYCLE_PERMISSIONS_PROJECT_GROUP_FILTERS),
    filters,
})
export const setLifecyclePermissionsProjectGroupSelected = (selected: readonly number[]) => ({
    type: inferLiteral(types.LIFECYCLE_PERMISSIONS_PROJECT_GROUP_SELECTED),
    selected,
})

// not assigned users
export const setLifecyclePermissionsUserIds = (userIds: readonly number[]) => ({
    type: inferLiteral(types.LIFECYCLE_PERMISSIONS_USER_IDS),
    userIds,
})
export const setLifecyclePermissionsUserSort = (sortColumn: keyof MtUser, sortOrder: OrderType) => ({
    type: inferLiteral(types.LIFECYCLE_PERMISSIONS_USER_SORT),
    sortColumn,
    sortOrder,
})
export const setLifecyclePermissionsUserFilters = (filters: UserFilters) => ({
    type: inferLiteral(types.LIFECYCLE_PERMISSIONS_USER_FILTERS),
    filters,
})
export const setLifecyclePermissionsUserSelected = (selected: readonly number[]) => ({
    type: inferLiteral(types.LIFECYCLE_PERMISSIONS_USER_SELECTED),
    selected,
})

export const setLifecyclePermissionsReloadList = (value: boolean) => ({
    type: inferLiteral(types.LIFECYCLE_PERMISSIONS_RELOAD_LIST),
    value,
})
